import { ChainId } from '@etcswapv2/sdk-legacy'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0xeefBa1e63905eF1D7ACbA5a8513c70307C1cE441',
  [ChainId.ROPSTEN]: '0x53C43764255c17BD724F74c4eF150724AC50a3ed',
  [ChainId.RINKEBY]: '0x42Ad527de7d4e9d9d011aC45B31D8551f8Fe9821',
  [ChainId.GÖRLI]: '0x77dCa2C955b15e9dE4dbBCf1246B4B85b651e50e',
  [ChainId.KOVAN]: '0x2cc8688C5f75E365aaEEb4ea8D6a480405A48D2A',
  [ChainId.CLASSIC]: '0x900cD941a2451471BC5760c3d69493Ac57aA9698',
  [ChainId.MORDOR]: '0x41Fa0143ea4b4d91B41BF23d0A03ed3172725C4B'
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
